import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import EmbedIcon from '../../../../../icons/compiled/components/EmbedIcon';
import parentStyles from '../styles.scss';
import styles from './styles.scss';
export class EmbedButton extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleClick", e => {
      e.preventDefault();
      e.stopPropagation();
      this.props.onClick();
    });
  }
  render() {
    const {
      dataHook,
      className,
      ariaLabel,
      disabled,
      tooltip
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip
    }, /*#__PURE__*/React.createElement("button", {
      "data-hook": dataHook,
      className: styles.icon + " " + className,
      "aria-hidden": disabled,
      disabled: disabled,
      onClick: this.handleClick,
      "aria-label": ariaLabel
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      className: parentStyles.icon + " " + styles.icon,
      icon: /*#__PURE__*/React.createElement(EmbedIcon, null)
    })));
  }
}
//# sourceMappingURL=embed-button.js.map